import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fault",
  "use": "icon-fault-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-fault\">\r\n  <defs>\r\n    <style>\r\n      #icon-fault .cls-1 {\r\n        fill: #606266;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-fault_故障\" class=\"cls-1\" d=\"M394.037,669a1.917,1.917,0,0,1-1.365-.566l-5.461-5.457a6.137,6.137,0,0,1-7.926-7.652,0.858,0.858,0,0,1,1.423-.347l2.333,2.333a0.873,0.873,0,0,0,1.232,0l1.03-1.03a0.869,0.869,0,0,0,0-1.23l-2.334-2.333a0.857,0.857,0,0,1,.347-1.422,6.136,6.136,0,0,1,7.656,7.922l5.46,5.458a1.914,1.914,0,0,1,0,2.729l-1.03,1.029A1.917,1.917,0,0,1,394.037,669Zm-6.7-7.172a0.531,0.531,0,0,1,.375.155l5.7,5.7a0.892,0.892,0,0,0,1.232,0l1.03-1.03a0.855,0.855,0,0,0,0-1.23l-5.706-5.7a0.531,0.531,0,0,1-.113-0.581,5.076,5.076,0,0,0-5.9-6.928l2.088,2.088a1.928,1.928,0,0,1,0,2.729l-1.029,1.029a1.934,1.934,0,0,1-2.731,0l-2.089-2.087a5.077,5.077,0,0,0,6.932,5.9A0.513,0.513,0,0,1,387.341,661.83Z\" transform=\"translate(-379 -651)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fault.svg
// module id = ILZP
// module chunks = 127